import { Helmet } from 'react-helmet'

const Head = () => {
	return (
		<Helmet>
			<title>Guruhlar</title>
		</Helmet>
	)
}

export default Head
